import { Footer } from '@/components/Footer';
import { NotFoundPage } from '@/components/NotFoundPage';
import { TrackHeader } from '@/components/TrackHeader';

const TrackingNotFound = () => {
  return (
    <div className='flex min-h-[100dvh] w-full flex-1 flex-col bg-[#f5f7f8]'>
      <TrackHeader />
      <NotFoundPage fullPage variant='tracking' />
      <Footer />
    </div>
  );
};

export { TrackingNotFound };
